import { Injectable } from '@angular/core';
import { CrowdtestQuestionnaireService } from './crowdtest-questionnaire.service';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  userInfo$ = new BehaviorSubject<any>(null);
  userInfo;

  apiPrefix = `${environment.serverHost}`;
  userInfoUrl = `${this.apiPrefix}/public/user_profile`;
  loginCompleteUrl = `${this.apiPrefix}/auth/public_web_complete`;
  constructor(
    private http: CrowdtestQuestionnaireService
  ) { }

  getUserInfo() {
    this.http.get(this.userInfoUrl).subscribe(userInfo => {
      this.userInfo = userInfo;
      console.log('userInfo: ', userInfo);
      this.userInfo$.next(this.userInfo);
    }, err => {
      console.log('err: ', err);
      this.userInfo$.next(undefined);
    })
  }

  loginComplete(data) {
    return this.http.post(this.loginCompleteUrl, data, { withCredentials: true });
  }


}
